var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3145_151407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.667 3.33341L9.72033 4.28008L8.66033 3.22008V10.6667H7.34033V3.22008L6.28033 4.28008L5.33366 3.33341L8.00033 0.666748L10.667 3.33341ZM13.3337 6.66675V14.0001C13.3337 14.7334 12.7337 15.3334 12.0003 15.3334H4.00033C3.26033 15.3334 2.66699 14.7334 2.66699 14.0001V6.66675C2.66699 5.92675 3.26033 5.33342 4.00033 5.33342H6.00033V6.66675H4.00033V14.0001H12.0003V6.66675H10.0003V5.33342H12.0003C12.7337 5.33342 13.3337 5.92675 13.3337 6.66675Z",
    fill: "#4CD7F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3145_151407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosShare);
export default __webpack_public_path__ + "static/media/ios-share.3c326d8fc6e000460423de7c5cb00f3f.svg";
export { ForwardRef as ReactComponent };